// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","AdSlotBranding__desktopWrap":"bgx_a","AdSlotBranding__desktop":"bgx_b","AdSlotBranding__mobile":"bgx_c"};